// @ts-expect-error build-time virtual module
import { bender } from 'legacy-hubspot-bender-context';
// @ts-expect-error no declaration file
import { reconfigure } from 'raven-hubspot/configure';
import { setParentPackage } from 'quartz/framework/environment/service';
import { setAppInfo } from 'hub-http/helpers/appInfo';
import { setStaticAppInfo } from 'metrics-js';
import { getQuartzConfig } from 'quartz-config/evaluable';
import { invariant } from 'quartz/invariant';
export function activateApp(adapter, authResult, prepareApp) {
  const quartzConfig = getQuartzConfig();
  /* invariant(quartzConfig.type === 'application') */
  ;
  setParentPackage(bender.bundlingPackage, bender.bundlingPackageVersion);
  setAppInfo(bender.bundlingPackage, bender.bundlingPackageVersion);
  setStaticAppInfo({
    package: bender.bundlingPackage,
    version: bender.bundlingPackageVersion
  });
  const logFetchOptions = quartzConfig.logFetchErrors && quartzConfig.logFetchErrors.options;
  reconfigure({
    project: bender.currentProject,
    release: bender.currentProjectVersion,
    ignoreErrors: logFetchOptions ? logFetchOptions.ignoreErrors : undefined,
    ignoreUrls: logFetchOptions ? logFetchOptions.ignoreUrls : undefined
  });
  adapter.setGlobalState(authResult);
  adapter.initializeWithState();
  return prepareApp();
}